import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2978c4f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notfound-wrap" }

import Main from '@teams/common/components/error/main.vue'
import notFoundImg from '@/assets/groupStatus/notFound.svg'

export default /*#__PURE__*/_defineComponent({
  __name: 'inviteNotFound',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Main, {
      img: _unref(notFoundImg),
      title: "空间链接不存在",
      desc: "请联系管理员重新获取邀请链接"
    }, null, 8, ["img"])
  ]))
}
}

})